<template lang="pug">
.alert-content
  h1 Alert Content
  p body
  button(@click="$emit('resolve')") Close
</template>

<script>
export default {
}
</script>